import { TagFilled } from '@ant-design/icons';
import { Space, Tag, Tooltip } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskLabels = function TaskLabels(_ref) {
  var labels = _ref.labels,
      max = _ref.max;
  var shownLabels = useMemo(function () {
    return max ? labels === null || labels === void 0 ? void 0 : labels.slice(0, max) : labels;
  }, [labels]);
  var otherLabels = useMemo(function () {
    return max ? labels === null || labels === void 0 ? void 0 : labels.slice(max).map(function (label) {
      return label.name;
    }) : [];
  }, [labels, max]);
  var otherLabelNames = useMemo(function () {
    return otherLabels === null || otherLabels === void 0 ? void 0 : otherLabels.join(', ');
  }, [otherLabels]);
  var hasMore = useMemo(function () {
    return (otherLabels === null || otherLabels === void 0 ? void 0 : otherLabels.length) > 0;
  }, [otherLabels]);

  if ((shownLabels === null || shownLabels === void 0 ? void 0 : shownLabels.length) === 0) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsxs(Container, {
    direction: "horizontal",
    children: [shownLabels === null || shownLabels === void 0 ? void 0 : shownLabels.map(function (label) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: label.name,
        children: /*#__PURE__*/_jsx(TagFilled, {
          style: {
            color: label.color
          }
        })
      }, label.id);
    }), hasMore && /*#__PURE__*/_jsx(Tooltip, {
      title: otherLabelNames,
      children: /*#__PURE__*/_jsxs(Tag, {
        title: otherLabelNames,
        children: ["+", otherLabels.length]
      })
    }, "more")]
  });
};
var Container = styled(Space).withConfig({
  displayName: "Labels__Container",
  componentId: "sc-1uxvi0-0"
})(["overflow:hidden;.ant-tag{margin-right:0px;border-radius:6px;&.withoutText{padding-right:0px;}}"]);